import { gql } from '@apollo/client';

export const GET_VOICE_STEP_AUDIO = gql`
  query getVoiceStepAudio($stepId: String!, $audioField: String!) {
    voiceStepAudio(stepId: $stepId, audioField: $audioField)
  }
`;
